import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';

interface HeaderActionListProps {
  children: ReactNode; // Accept any valid React children
}

// This applies the header action item styling to all its children.
// Paired with the HeaderAction component, this gives styling by default.
// fontSize array is for different breakpoints: xs, sm, md and above.
export default function HeaderActionList({ children }: HeaderActionListProps) {
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      {React.Children.map(children, (child) => (
        <Box
          paddingTop={1}
          paddingBottom={1}
          paddingLeft={2}
          paddingRight={2}
          sx={{
            fontSize: ['1.2rem', '1.2rem', '0.9rem'],
            pointerEvents: 'none', // Disables pointer events unless there is a pointer event on a child with auto.
            '&:hover': {
              color: '#42806f',
              background: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          {React.isValidElement(child) ? React.cloneElement(child) : child}
        </Box>
      ))}
    </Box>
  );
}
